// extracted by mini-css-extract-plugin
export var cartIcon = "_l8-0";
export var cartIconContainer = "_l8-1";